<template>
  <div>
    <filter-bar name="devices" :filter="getDevicesFilter" />
    <div v-if="deviceLocations && getDevicesReady" style="min-height: 84vh;">
      <locations
        :_deviceLocations="
          currentClient.client_name === 'shark'
            ? groupLocations
            : deviceLocations
        "
      />
    </div>
    <filters />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Locations from '@/components/app/Locations.vue';
import FilterBar from '@/components/app/FilterBar.vue';
import Filters from '@/components/filter/Filters';

export default {
  components: {
    Locations,
    FilterBar,
    Filters,
  },
  data() {
    return {
      loadMap: false,
    };
  },
  methods: {
    ...mapActions({
      getDevices: 'maps/getDeviceLocations',
    }),
  },
  computed: {
    ...mapGetters({
      groupLocations: 'maps/getGroupLocations',
      deviceLocations: 'maps/getDevices',
      getDevicesReady: 'maps/getDevicesReady',
      getDevicesFilter: 'filters/getFilter',
      currentClient: 'account/getCurrentClient',
    }),
  },
  mounted() {
    // this.getDevices(this.currentClient);
    this.loadMap = true;
  },
};
</script>
